import script from "./ListAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./ListAssets.vue?vue&type=script&setup=true&lang=js"

import "./ListAssets.vue?vue&type=style&index=0&id=1a23e3ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a23e3ce"]])

export default __exports__